module.exports = __webpack_public_path__ + "static/media/comment-icon.430a9a92.svg";